import React from 'react';
import './Terms.css';
import { useLocalContext } from '../../context/LocalContext';

const Terms = () => {
  const { webinfo } = useLocalContext();

  return (
    <div className="privacy-policy">
      <div className="privacy-policy-header">
        <h2>Terms & Conditions</h2>
      </div>
      <div className="privacy-policy-content">

        <h3>1. Agreement to Terms</h3>
        <p>
          By accessing or using the services provided by <strong>{webinfo.name}</strong>, you agree to comply with and be legally bound by these Terms & Conditions. If you do not accept them, please discontinue use of our services.
        </p>

        <h3>2. Scope of Services</h3>
        <p>
          We offer a range of digital solutions including strategy, branding, web development, SEO, paid advertising, automation, and analytics. The specifics of each engagement will be detailed in our proposal or contract.
        </p>

        <h3>3. Platform & Policy Compliance</h3>
        <p>
          Our team follows the guidelines of platforms like Google Ads, Meta, and LinkedIn. We will not support campaigns or materials that violate ad policies, including misleading claims, prohibited content, or improper data usage.
        </p>

        <h3>4. Analytics, Tracking & Consent</h3>
        <p>
          We use tools such as Google Analytics, Meta Pixel, and other trackers to optimize results. By working with us, you confirm your website has an updated privacy notice explaining cookie usage and visitor tracking, as required by law.
        </p>

        <h3>5. Payment Terms</h3>
        <p>
          Services are billed upfront or on agreed milestones. Delays in payment may pause service delivery. Terms, timelines, and payment methods will be specified in our agreement or invoice.
        </p>

        <h3>6. Ownership of Work</h3>
        <p>
          All digital assets, creatives, and code remain the property of <strong>{webinfo.name}</strong> until full payment is received. Once settled, rights to the deliverables are transferred to you, excluding licensed tools or third-party content.
        </p>

        <h3>7. Confidentiality</h3>
        <p>
          Any non-public or sensitive business information shared with us will be treated confidentially. We do not share, sell, or disclose client data to third parties unless legally required.
        </p>

        <h3>8. Results Disclaimer</h3>
        <p>
          We make every effort to achieve strong outcomes, but we cannot guarantee specific rankings, sales, or performance metrics. Results may vary due to external factors like algorithm changes or competition.
        </p>

        <h3>9. Cancellation & Refunds</h3>
        <p>
          You may cancel a project with written notice (minimum 7 days). Any completed work or expenses will be invoiced. We reserve the right to discontinue service for violations or non-cooperation.
        </p>

        <h3>10. Third-Party Services</h3>
        <p>
          If we integrate tools like Google Ads, Mailchimp, or CRMs, we are not responsible for their outages, changes, or terms. You must comply with their usage policies separately.
        </p>

        <h3>11. Legal Jurisdiction</h3>
        <p>
          These terms are governed by the laws of India. Any legal disputes shall fall under the jurisdiction of local courts based on our registered location or mutual agreement.
        </p>

        <h3>12. Updates to These Terms</h3>
        <p>
          We may revise these terms from time to time. Continued use of our services after changes implies your acceptance of the updated terms.
        </p>

        <h3>13. Contact Information</h3>
        <p>
          For legal queries or concerns, reach us at <strong>{webinfo.email}</strong> or call <strong>{webinfo.phone}</strong>.
        </p>

      </div>
    </div>
  );
};

export default Terms;
